define(['jquery', 'postalhelper', 'common', 'erv_tracking', 'masking'], function ($, ERVPostalHelper, Common, ERVTracking, Masking) {
	var BookingStepTwo = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.backendDomain = self.$ervBody.find('#main-content').attr('data-js-backenddomain');
		self.common = new Common();
		self.tracking = new ERVTracking();
		self.postalHelper = new ERVPostalHelper();

		self.initEventhandlers = function () {
			var $policyHolderId = self.$ervBody.find('#Input_PolicyHolderId');
			$policyHolderId.on('change', function () {
				self.$ervBody.find("#other-person-maker").toggleClass('hide', $(this).val().replace('\u2212', '\u002D') !== '-1');
				self.$ervBody.find("#other-company-maker").toggleClass('hide', $(this).val().replace('\u2212', '\u002D') !== '-2');
				$("[data-js='require-company-input']").val($(this).val().replace('\u2212', '\u002D') === '-2' ? "True" : "False");
			});

			self.$ervBody.find('[data-js="trigger-namechange"]').on('blur', function () {
				var $trigger = $(this),
					$triggerParent = $trigger.parents('.person'),
					displayIndex = $triggerParent.find('.avatar .index').text(),
					$firstName = $triggerParent.find('.name input').first(),
					$lastName = $triggerParent.find('.name input').last(),
					$responsibleDropDownItem = self.$ervBody.find('#Input_PolicyHolderId option[value=' + (Number(displayIndex) - 1) + ']');

				if ($firstName.val() !== '' || $lastName.val() !== '')
					$responsibleDropDownItem.text($firstName.val() + ' ' + $lastName.val());
			});

			self.$ervBody.find('[data-trigger="copy-lastname"]').first().on('blur', function () {
				var $copyTriggerContainer = self.$ervBody.find('#copy-container'),
					$lastName = $(this);

				if ($lastName.val() !== '') {
					$copyTriggerContainer.removeClass('hide');
				} else {
					$copyTriggerContainer.addClass('hide');
				}
			});

			self.$ervBody.find('[data-js="trigger-copy-lastname"]').on('click', function (e) {
				e.preventDefault();
				var $lastName = self.$ervBody.find('[data-trigger="copy-lastname"]'),
					$listWithLastnamesToFill = self.$ervBody.find('#included-persons');

				$listWithLastnamesToFill.find('input[name$=".LastName"]').each(function() {
					var $input = $(this);
					$input.val($lastName.val());
					$input.trigger('blur');
				});
			});

			self.$ervBody.find('[data-js="yestorenewal"]').on('change', function () {
				var $checkbox = $(this), $additionalRenewal = self.$ervBody.find('.renewal [data-js="additionalrenewal"]');

				if ($checkbox.prop('checked')) {
					$additionalRenewal.removeClass('hide');
					self.common.forms.disableFormElementsInContainer($additionalRenewal, false);
				} else {
					$additionalRenewal.addClass('hide');
					self.common.forms.disableFormElementsInContainer($additionalRenewal, true);
				}
			});

			self.$ervBody.find('[data-js="trigger-annual-upgrade"]').on('click', function (e) {
				e.preventDefault();

				var $this = $(this),
					$form = $this.parents('form');

				if (!$form.valid()) {
					return;
				}

				$form.attr('action', $this.data('action'));

				var value = Math.round(Number($this.data('upgrade-price')));

				self.common.forms.activateLoading($form, false);

				self.tracking.trackEvent('Booking', 'Annual Upgrade', $this.data('product'), value < 0 ? 0 : value, function () {
					$form.submit();
				});
			});

			self.$ervBody.find('[data-js = "maskingCPRNumber"]').on('input', function() {
				Masking.MaskingCPRNumber(this);
			});

			self.$ervBody.find('[data-js = "maskingCVRNumber"]').on('input', function () {
				Masking.MaskingCVRNumber(this, self.backendDomain);
			});
		};
	};

	BookingStepTwo.prototype.init = function () {
		var self = this;
		self.initEventhandlers();
		self.postalHelper.init();

		//scroll to renewal if upgrade triggered and form is valid
		var $renewal = self.$ervBody.find('.box.renewal.choice');
		if ($renewal.length !== 0 && self.$ervBody.find('form').valid() === true && document.URL.indexOf(document.referrer) > -1) {
			setTimeout(function () {
				var scrollingElement = (document.scrollingElement || document.body);
				scrollingElement.scrollTop = scrollingElement.scrollHeight;
			}, 100);
		}
	}

	return BookingStepTwo;
});